import React, { useState } from "react";
import Heading from "../../../components/shared/Heading";
import { Button, ToggleButtonGroup } from "./styles";
import { useHistory } from "react-router";
import { Grid } from "@mui/material";
import { SEText } from "../../../components/SEText";
import { ThemeProvider } from "@mui/material";
import theme from "../../../mui-theme";
import { Panel } from "./components/Panel";
import { Reports } from "./components/Reports";
import { useQuery } from "react-query";
import { AtendimentosSSEService } from "./services";
import useFilterHandler from "../../../hooks/useFilterHandler";

export const AtendimentosSala = () => {
  const { setFilterOptions } = useFilterHandler();

  const history = useHistory();
  const [isPanel, setIsPanel] = useState<boolean>(false);
  const [tabSelected, setTabSelected] = useState("Gerencial");

  const handleSelectPanel = (value: boolean) => {
    setIsPanel(value);
    const param = value ? "panel" : "report";
    history.push({ search: `?type=${param}` });
  };

  useQuery({
    queryFn: () => {
      const abortController = new AbortController() as any;
      return AtendimentosSSEService.getFilterOptions(abortController?.signal);
    },
    queryKey: ["abaPorAgenteOptionsData"],
    onSuccess: (data) => {
      setFilterOptions(data);
    },
  });

  return (
    <Grid container spacing={2}>
      <ThemeProvider theme={theme}>
        <Heading
          as={"h1"}
          size={"large"}
          font={"Campuni"}
          style={{ display: "flex", marginRight: "40px", marginLeft: "40px" }}
        >
          Atendimentos Sala:
          <SEText color={"#0061C6"} style={{ marginLeft: 4 }}>
            {tabSelected}
          </SEText>
        </Heading>
        <ToggleButtonGroup>
          <Button selected={isPanel} onClick={() => handleSelectPanel(true)}>
            Painel visual
          </Button>
          <Button selected={!isPanel} onClick={() => handleSelectPanel(false)}>
            Relatórios
          </Button>
        </ToggleButtonGroup>
        {isPanel ? <Panel /> : <Reports {...{ tabSelected, setTabSelected }} />}
      </ThemeProvider>
    </Grid>
  );
};
